import { PageWithTitle } from 'utils/PageWithTitle'
import { useAuth } from 'context/authentication/useAuth'
import styled from 'styled-components/macro'
import { MobileAuthenticatedNav } from 'components/Layout/Navbar/MobileAuthenticatedNav'
import { MobileUnauthenticatedNav } from 'components/Layout/Navbar/MobileUnauthenticatedNav'
import {
  MobileUnauthenticatedFooter,
  MobileFooter,
} from 'components/Layout/Footer/MobileFooter'
import MobileNotReady from 'components/NotFoundCard/MobileNotReady'
import { ChevronLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { BackButton } from 'components/MobileSearch/MobileSearch.styles'

export default function MobileNotFound() {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const [canGoBack, setCanGoBack] = useState(false)

  useEffect(() => {
    const historyState = window.history.state
    setCanGoBack(historyState && historyState.idx > 0)
  }, [])

  const Navbar = isAuthenticated
    ? MobileAuthenticatedNav
    : MobileUnauthenticatedNav

  const Footer = isAuthenticated ? MobileFooter : MobileUnauthenticatedFooter

  return (
    <PageWithTitle title="Not Found">
      <LayoutRoot>
        <Navbar />
        {canGoBack && (
          <BackButton onClick={() => navigate(-1)}>
            <ChevronLeft size={20} />
            <span>Back</span>
          </BackButton>
        )}
        <Content>
          <MobileNotReady />
        </Content>
        <Footer />
      </LayoutRoot>
    </PageWithTitle>
  )
}

const LayoutRoot = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  width: 100%;
`

const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`
